module.exports = __webpack_public_path__ + "img/google-chrome.7f2603a4.svg";